export default {
  questions: {
    common: {
      dropdownPlaceholder: 'Bitte auswählen:'
    },
    comments: {
      additionalComments: 'Zusätzliche Kommentare',
      enter: 'Geben Sie Ihren Text hier ein',
      title: 'Haben Sie sonstige Kommentare, die Sie mit uns teilen möchten?' //Dynamic use

    },
    menuInsight: {
      areYouSureYouWantToClose: 'Sind Sie sicher, dass Sie schließen möchten?',
      theInformationYouHaveEnteredHere: 'Die hier eingegebenen Informationen werden nicht gespeichert.',
      moreCharactersRequired: 'Geben Sie drei oder mehr Zeichen ein, um nach Ihrem Artikel zu suchen.'
    },
    nps: {
      notVeryLikely: 'Eher unwahrscheinlich',
      sliderDesc: 'Tippen Sie unten, um eine Punktzahl auszuwählen',
      sliderDirtyDesc: 'Zum Ändern Ihrer Punktzahl verschieben',
      veryLikely: 'Sehr wahrscheinlich'
    },
    questions: {
      na: 'Nicht zutreffend'
    },
    staff: {
      areYouSureYouWantToClose: 'Sind Sie sicher, dass Sie schließen möchten?',
      theInformationYouHaveEnteredHereWontBeSaved: 'Die hier eingegebenen Informationen werden nicht gespeichert.'
    },
    yesNoWhy: {
      whyIsThat: 'Warum ist das so?'
    },
    saveAndContinue: 'Speichern und Fortfahren',
    areYouSureYouWantToClose: 'Sind Sie sicher, dass Sie schließen möchten?',
    theInformationYouHaveEnteredHere: 'Die hier eingegebenen Informationen werden nicht gespeichert.'
  }
};